export default __webpack_public_path__ + "static/valore-logo-white-e583e96f9be542663b3a0e3928b99fa8.png";